import * as React from "react";
import {Business, CardTransaction} from "../../types/Types";
import {convertTimestampToDateAndTime} from "../../utils/Utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";

interface Props {
  cardTransaction: CardTransaction,
  business: Business | undefined,
}

function TransactionRow(props: Props) {
  return (
      <div className={"basic-box colour-secondary mb-0"}>
        {props.business && <div className={"d-inline-block"}><b>{props.business.name}</b></div>}
        <div className={`d-inline-block float-right tag font-1 ${props.cardTransaction.type == "CREDIT" ? 'green' : 'red'} `}>
          <div className={"d-inline-block"}>
            {props.cardTransaction.points}<FontAwesomeIcon className={"ms-1"} icon={faStar}/>
          </div>
        </div>
        <div className={"font-md"}>{convertTimestampToDateAndTime(props.cardTransaction.createdAt)}</div>
      </div>
  )
}

export default TransactionRow;